import type { ThemeDefinition } from "./types";
import { hexToSrgb, hexToLinear } from "./palette";

export const chalk: ThemeDefinition = {
  label: "Chalk",
  className: "theme-chalk",
  bg: "#ece8f4",
  text: "#5a4080",
  textMuted: `color-mix(in srgb, #5a4080 60%, transparent)`,
  accent: "#d06888",
  glassRgb: "236,232,244",
  border: "rgba(255,255,255,0.50)",
  borderHighlight: "rgba(255,255,255,0.50)",
  separator: `color-mix(in srgb, #5a4080 30%, transparent)`,
  selection: "#5a4080",
  selectionText: "#ffffff",
  gridColor: "#d4cce4",
  noiseOpacity: "0.03",
  gridOpacity: "0.7",
  textShadow: "0 -1px 0px rgba(255,255,255,0.4), 0 10px 0px rgba(30,20,50,0.15)",
  gpuClear: hexToSrgb("#ece8f4"),
  gpuGridLine: hexToLinear("#d4cce4"),
  gpuGridAlpha: 0.7,
  gpuAxisX: hexToLinear("#d06888"),
  gpuAxisZ: hexToLinear("#5a4080"),
  axisXColor: "#d06888",
  axisZColor: "#5a4080",
  font: '"Inter", sans-serif',
  fontImport: 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap',
};
